export const CREATE_ALBUM = 'ALBUM/CREATE';
export const ADD_MUSIC = 'ALBUM/ADD_MUSIC';
export const LOAD_ALBUMS = 'ALBUMS/LOAD';
export const LOAD_ALBUM = 'ALBUM/LOAD';
export const DELETE_ALBUM = 'ALBUM/DELETE';
export const LOADING_STATUS = 'ALBUM/LOADING_STATUS';
